export const mobile = 320;
export const tablet = 768;
export const desktop = 1024;

/** @deprecated Use `mediaQuery` helpers instead */
export const mobileQuery = "320";
/** @deprecated Use `mediaQuery` helpers instead */
export const tabletQuery = "768";
/** @deprecated Use `mediaQuery` helpers instead */
export const desktopQuery = "1024";

/**
 * Mobile-first media query helpers for use in styled-components.
 *
 * Usage:
 *   ${mediaQuery.tablet} { ... }  // applies from 768px and up
 *   ${mediaQuery.desktop} { ... } // applies from 1024px and up
 */
export const mediaQuery = {
    tablet: `@media (min-width: ${tablet}px)`,
    desktop: `@media (min-width: ${desktop}px)`,
} as const;